import { Link } from '@tanstack/react-router'
import clsx from 'clsx'
import type { RefObject } from 'react'
import { usePathViewedActivity } from '~/api/queries/pathViewed'
import { NotificationIndicator } from '~/components/Global/Elements/NotificationIndicator/NotificationIndicator'
import {
  sidebarLink,
  sidebarLinkActive
} from '~/pages/styles/settings/Settings.css'
import { buildV3Url } from '~/utils/legacy'

export type SettingsMenuItemData = {
  label: string
  tags?: string[]
  to?: string
  href?: string
  requiresAdmin?: boolean
  requiresSuperAdmin?: boolean
  requiresAccountant?: boolean
  requiresTalentplug?: boolean
  requiresFactor?: boolean
  requiresAdvertsdata?: boolean
  requiresArmado?: boolean
  requiresTempo?: boolean
  requiresExtensions?: boolean
  requiresDPO?: boolean
  requiresInvoiceEnabled?: boolean
}

type Props = {
  item: SettingsMenuItemData
  isActive: boolean
  legacyUrl: string | null
  activeRef: RefObject<HTMLAnchorElement | HTMLSpanElement | null>
}

export const SettingsMenuItem = ({
  item,
  isActive,
  legacyUrl,
  activeRef
}: Props) => {
  const { hasNewActivity } = usePathViewedActivity(item.to)

  if (item.to) {
    if (window.JobConfig) {
      return (
        <a
          href={buildV3Url(item.to)}
          className={clsx(sidebarLink, isActive ? sidebarLinkActive : null)}
          ref={
            isActive ? (activeRef as RefObject<HTMLAnchorElement>) : undefined
          }
        >
          <span>{item.label}</span>
          {hasNewActivity && <NotificationIndicator />}
        </a>
      )
    }
    return (
      <Link
        to={item.to}
        className={clsx(sidebarLink, isActive ? sidebarLinkActive : null)}
        ref={isActive ? (activeRef as RefObject<HTMLAnchorElement>) : undefined}
      >
        <span>{item.label}</span>
        {hasNewActivity && <NotificationIndicator />}
      </Link>
    )
  }

  if (item.href) {
    return (
      <a
        href={`${legacyUrl}${item.href}`}
        className={clsx(sidebarLink, isActive ? sidebarLinkActive : null)}
        ref={isActive ? (activeRef as RefObject<HTMLAnchorElement>) : undefined}
      >
        <span>{item.label}</span>
      </a>
    )
  }

  return null
}
